import {LidCollar, LidType, LidVariant, Plan} from "../../types";
import {hasMultiRowManholes, lidIsFullyCoveredByManhole} from "./lid";

export interface LidSpecsRow {
    id: string
    lidType: LidType
    collar: LidCollar
    variant: LidVariant

    defaultHeightMm: number
    minHeightMm: number

    lidTopToBevelTopMm: number
    bevelHeightMm: number
}

export const lidSpecs: LidSpecsRow[] = [
    // A15
    // beveled
    {
        id: "A15.beveled.standard",
        lidType: "A15",
        collar: "beveled",
        variant: "standard",
        defaultHeightMm: 200,
        minHeightMm: 200,
        lidTopToBevelTopMm: 30,
        bevelHeightMm: 40
    },
    {
        id: "A15.beveled.noopening",
        lidType: "A15",
        collar: "beveled",
        variant: "noopening",
        defaultHeightMm: 250,
        minHeightMm: 0,
        lidTopToBevelTopMm: 30,
        bevelHeightMm: 40
    },
    {
        id: "A15.beveled.oversize",
        lidType: "A15",
        collar: "beveled",
        variant: "oversize",
        defaultHeightMm: 250,
        minHeightMm: 230,
        lidTopToBevelTopMm: 30,
        bevelHeightMm: 20
    },
    // lifted
    {
        id: "A15.lifted.standard",
        lidType: "A15",
        collar: "lifted",
        variant: "standard",
        defaultHeightMm: 200,
        minHeightMm: 200,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    {
        id: "A15.lifted.noopening",
        lidType: "A15",
        collar: "lifted",
        variant: "noopening",
        defaultHeightMm: 200,
        minHeightMm: 0,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    {
        id: "A15.lifted.oversize",
        lidType: "A15",
        collar: "lifted",
        variant: "oversize",
        defaultHeightMm: 200,
        minHeightMm: 180,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    // without
    {
        id: "A15.without.standard",
        lidType: "A15",
        collar: "without",
        variant: "standard",
        defaultHeightMm: 85,
        minHeightMm: 85,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    {
        id: "A15.without.noopening",
        lidType: "A15",
        collar: "without",
        variant: "noopening",
        defaultHeightMm: 0,
        minHeightMm: 0,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    {
        id: "A15.without.oversize",
        lidType: "A15",
        collar: "without",
        variant: "oversize",
        defaultHeightMm: 85,
        minHeightMm: 85,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    // B125
    // beveled
    {
        id: "B125.beveled.standard",
        lidType: "B125",
        collar: "beveled",
        variant: "standard",
        defaultHeightMm: 200,
        minHeightMm: 200,
        lidTopToBevelTopMm: 30,
        bevelHeightMm: 40
    },
    {
        id: "B125.beveled.noopening",
        lidType: "B125",
        collar: "beveled",
        variant: "noopening",
        defaultHeightMm: 250,
        minHeightMm: 0,
        lidTopToBevelTopMm: 30,
        bevelHeightMm: 40
    },
    {
        id: "B125.beveled.oversize",
        lidType: "B125",
        collar: "beveled",
        variant: "oversize",
        defaultHeightMm: 250,
        minHeightMm: 230,
        lidTopToBevelTopMm: 30,
        bevelHeightMm: 20
    },
    {
        id: "B125.beveled.multirow",
        lidType: "B125",
        collar: "beveled",
        variant: "multirow",
        defaultHeightMm: 350,
        minHeightMm: 300,
        lidTopToBevelTopMm: 30,
        bevelHeightMm: 20
    },
    // lifted
    {
        id: "B125.lifted.standard",
        lidType: "B125",
        collar: "lifted",
        variant: "standard",
        defaultHeightMm: 200,
        minHeightMm: 200,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    {
        id: "B125.lifted.noopening",
        lidType: "B125",
        collar: "lifted",
        variant: "noopening",
        defaultHeightMm: 220,
        minHeightMm: 0,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    {
        id: "B125.lifted.oversize",
        lidType: "B125",
        collar: "lifted",
        variant: "oversize",
        defaultHeightMm: 220,
        minHeightMm: 200,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    {
        id: "B125.lifted.multirow",
        lidType: "B125",
        collar: "lifted",
        variant: "multirow",
        defaultHeightMm: 350,
        minHeightMm: 300,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    // without
    {
        id: "B125.without.standard",
        lidType: "B125",
        collar: "without",
        variant: "standard",
        defaultHeightMm: 80,
        minHeightMm: 80,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    {
        id: "B125.without.noopening",
        lidType: "B125",
        collar: "without",
        variant: "noopening",
        defaultHeightMm: 0,
        minHeightMm: 0,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    {
        id: "B125.without.oversize",
        lidType: "B125",
        collar: "without",
        variant: "oversize",
        defaultHeightMm: 80,
        minHeightMm: 80,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    // pavingready
    {
        id: "B125.pavingready.standard",
        lidType: "B125",
        collar: "pavingready",
        variant: "standard",
        defaultHeightMm: 200,
        minHeightMm: 200,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 0
    },
    {
        id: "B125.pavingready.noopening",
        lidType: "B125",
        collar: "pavingready",
        variant: "noopening",
        defaultHeightMm: 250,
        minHeightMm: 0,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 0
    },
    {
        id: "B125.pavingready.oversize",
        lidType: "B125",
        collar: "pavingready",
        variant: "oversize",
        defaultHeightMm: 250,
        minHeightMm: 230,
        lidTopToBevelTopMm: 50,
        bevelHeightMm: 0
    },
    {
        id: "B125.pavingready.multirow",
        lidType: "B125",
        collar: "pavingready",
        variant: "multirow",
        defaultHeightMm: 350,
        minHeightMm: 250,
        lidTopToBevelTopMm: 50,
        bevelHeightMm: 0
    },
    // D400
    // beveled
    {
        id: "D400.beveled.standard",
        lidType: "D400",
        collar: "beveled",
        variant: "standard",
        defaultHeightMm: 250,
        minHeightMm: 250,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 40
    },
    {
        id: "D400.beveled.noopening",
        lidType: "D400",
        collar: "beveled",
        variant: "noopening",
        defaultHeightMm: 300,
        minHeightMm: 0,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 40
    },
    {
        id: "D400.beveled.oversize",
        lidType: "D400",
        collar: "beveled",
        variant: "oversize",
        defaultHeightMm: 300,
        minHeightMm: 280,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 20
    },
    // lifted
    {
        id: "D400.lifted.standard",
        lidType: "D400",
        collar: "lifted",
        variant: "standard",
        defaultHeightMm: 250,
        minHeightMm: 250,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    {
        id: "D400.lifted.noopening",
        lidType: "D400",
        collar: "lifted",
        variant: "noopening",
        defaultHeightMm: 300,
        minHeightMm: 0,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    {
        id: "D400.lifted.oversize",
        lidType: "D400",
        collar: "lifted",
        variant: "oversize",
        defaultHeightMm: 300,
        minHeightMm: 280,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    // without
    {
        id: "D400.without.standard",
        lidType: "D400",
        collar: "without",
        variant: "standard",
        defaultHeightMm: 105,
        minHeightMm: 105,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    {
        id: "D400.without.noopening",
        lidType: "D400",
        collar: "without",
        variant: "noopening",
        defaultHeightMm: 0,
        minHeightMm: 0,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    {
        id: "D400.without.oversize",
        lidType: "D400",
        collar: "without",
        variant: "oversize",
        defaultHeightMm: 105,
        minHeightMm: 105,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    // pavingready
    {
        id: "D400.pavingready.standard",
        lidType: "D400",
        collar: "pavingready",
        variant: "standard",
        defaultHeightMm: 250,
        minHeightMm: 250,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 0
    },
    {
        id: "D400.pavingready.noopening",
        lidType: "D400",
        collar: "pavingready",
        variant: "noopening",
        defaultHeightMm: 300,
        minHeightMm: 0,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 0
    },
    {
        id: "D400.pavingready.oversize",
        lidType: "D400",
        collar: "pavingready",
        variant: "oversize",
        defaultHeightMm: 300,
        minHeightMm: 280,
        lidTopToBevelTopMm: 50,
        bevelHeightMm: 0
    },
    // E600
    // beveled
    {
        id: "E600.beveled.standard",
        lidType: "E600",
        collar: "beveled",
        variant: "standard",
        defaultHeightMm: 250,
        minHeightMm: 250,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 40
    },
    {
        id: "E600.beveled.noopening",
        lidType: "E600",
        collar: "beveled",
        variant: "noopening",
        defaultHeightMm: 300,
        minHeightMm: 0,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 40
    },
    {
        id: "E600.beveled.oversize",
        lidType: "E600",
        collar: "beveled",
        variant: "oversize",
        defaultHeightMm: 300,
        minHeightMm: 280,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 20
    },
    // lifted
    {
        id: "E600.lifted.standard",
        lidType: "E600",
        collar: "lifted",
        variant: "standard",
        defaultHeightMm: 250,
        minHeightMm: 250,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    {
        id: "E600.lifted.noopening",
        lidType: "E600",
        collar: "lifted",
        variant: "noopening",
        defaultHeightMm: 300,
        minHeightMm: 0,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    {
        id: "E600.lifted.oversize",
        lidType: "E600",
        collar: "lifted",
        variant: "oversize",
        defaultHeightMm: 300,
        minHeightMm: 280,
        lidTopToBevelTopMm: 0,
        bevelHeightMm: 0
    },
    // without
    {
        id: "E600.without.standard",
        lidType: "E600",
        collar: "without",
        variant: "standard",
        defaultHeightMm: 150,
        minHeightMm: 150,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    {
        id: "E600.without.noopening",
        lidType: "E600",
        collar: "without",
        variant: "noopening",
        defaultHeightMm: 0,
        minHeightMm: 0,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    {
        id: "E600.without.oversize",
        lidType: "E600",
        collar: "without",
        variant: "oversize",
        defaultHeightMm: 150,
        minHeightMm: 150,
        lidTopToBevelTopMm: 80,
        bevelHeightMm: 0
    },
    // pavingready
    {
        id: "E600.pavingready.standard",
        lidType: "E600",
        collar: "pavingready",
        variant: "standard",
        defaultHeightMm: 250,
        minHeightMm: 250,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 0
    },
    {
        id: "E600.pavingready.noopening",
        lidType: "E600",
        collar: "pavingready",
        variant: "noopening",
        defaultHeightMm: 300,
        minHeightMm: 0,
        lidTopToBevelTopMm: 40,
        bevelHeightMm: 0
    },
    {
        id: "E600.pavingready.oversize",
        lidType: "E600",
        collar: "pavingready",
        variant: "oversize",
        defaultHeightMm: 300,
        minHeightMm: 280,
        lidTopToBevelTopMm: 50,
        bevelHeightMm: 0
    },
]


export const getLidSpecs = (lidType: LidType, collar: LidCollar, variant: LidVariant) : LidSpecsRow | undefined => {
    return lidSpecs.find(spec => spec.lidType === lidType && spec.collar === collar && spec.variant === variant);
}

const getLidVariant = (plan: Plan) : LidVariant => {
    if (!plan.lid) return 'undefined';
    const hasNoOpenings = (plan.lid.manholes?.length ?? 0) < 1
        && (plan.lid.circularBlockOuts?.length ?? 0) < 1
        && (plan.lid.blockOuts?.length ?? 0) < 1

    if (hasNoOpenings) return 'noopening';
    if (hasMultiRowManholes(plan)) return 'multirow';
    if (lidIsFullyCoveredByManhole(plan) || !!plan.intermediateCeiling) return 'standard';
    return 'oversize';
}

export const getLidSpecsByPlan = (plan: Plan) : LidSpecsRow | null => {
    if (!plan.lid) return null;
    const lid = plan.lid;
    const type = lid.type;
    const collar = lid.collar;
    const variant = getLidVariant(plan);

    return getLidSpecs(type, collar, variant) ?? null;
}
